enum Focus {
  ACCOUNT, // 0
  ADS, // 1
  CHANNELS_CHOICE, // 2
  CHANNEL_GUIDE_LOGO, // 3
  CHANNEL_LIST, // 4
  CHANNEL_LIST_EVENTS, // 5
  CHANNEL_LIST_UPGRADE, // 6
  DETAIL_BUTTONS, // 7
  DETAIL_RELATED, // 8
  DETAIL_SYNOPSIS, // 9
  DISK, // 10
  FLOATING_MENU, // 11
  LANGUAGES, // 12
  LIST_BUTTONS, // 13
  LOGIN, // 14
  MAIN_EMPTY, // 15
  MANAGE_CHANNELS_BUTTONS, // 16
  MENU, // 17
  MODAL_BUTTONS, // 18
  MODAL_INPUT, // 19
  MODAL_LANGUAGE_AUDIO, // 20
  MODAL_LANGUAGE_SUBTITLES, // 21
  MODAL_ZOOM, // 22
  MOSAIC, // 23
  NEXT_EPISODE, // 24
  PAUSE_ADS, // 25
  PLAYER, // 26
  PROMO, // 27
  QUERY_LIST, // 28
  RAILS_LIST, // 29
  RAILS_SUB_LIST, // 30
  SEARCH, // 31
  SEARCH_KEYBOARD, // 32
  SLIDER_LIST, // 33
  SLIDER_SUB_LIST, // 34
  SLIDERS, // 35
  SPLASH, // 36
  SWITCHER, // 37
  WEBVIEW, // 38
  ZAPPER, // 39
}

export default Focus;
